let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("46t5f")).then(() => parcelRequire('2nrO6'));